import * as Data$dArray from "../Data.Array/index.js";
import * as Data$dMap$dInternal from "../Data.Map.Internal/index.js";
import * as Data$dOrd from "../Data.Ord/index.js";
import * as Data$dTime$dLocal from "../Data.Time.Local/index.js";
import * as Restaumatic$dMenu$dPromotions from "../Restaumatic.Menu.Promotions/index.js";
const filterPromotionsL = localDateTime => consumers => promotions => Data$dArray.filter(Restaumatic$dMenu$dPromotions.isAvailableAt(localDateTime)(consumers))(promotions);
const filterPromotions = utcTime => consumers => x => (
  {
    promotions: (() => {
      const $0 = Data$dTime$dLocal.utcToLocalDateTime(utcTime)(x.timeZone);
      return Data$dMap$dInternal.filterWithKey(Data$dOrd.ordInt)(v => Restaumatic$dMenu$dPromotions.isAvailableAt($0)(consumers))(x.promotions);
    })(),
    timeZone: x.timeZone,
    enableCoupons: x.enableCoupons,
    enableFod: x.enableFod,
    enableMarketingConsents: x.enableMarketingConsents,
    catalogue: x.catalogue,
    imagePrefix: x.imagePrefix
  }
);
export {filterPromotions, filterPromotionsL};
